import { Button } from 'antd'
import { ColumnType } from 'antd/es/table'
import dayjs from 'dayjs'
import { useNavigate, useParams } from 'react-router-dom'

import {
  GetSimeTbTreatmentPlanListResponseItem,
  GetTreatmentPlanListResponseItem
} from 'src/api/requests'
import { dayMonthYearBackSlash } from 'src/libs'
import { useLocales } from 'src/locales'
import { paths } from 'src/paths'

import { TreatmentStatusTag } from './components/TreatmentStatusTag'

export const useTreatmentColumns = (
  showPerson?: boolean,
  isSimeTB?: boolean
) => {
  const { t, currentLang } = useLocales()
  const navigate = useNavigate()
  const { id: personId, simeTBPersonId } = useParams()

  const columns: ColumnType<
    GetTreatmentPlanListResponseItem | GetSimeTbTreatmentPlanListResponseItem
  >[] = [
    {
      key: 'datetime',
      title: `${t('common.date')} ${t('treatments.treatment_start_date')}`,
      render: (_, { startDate }) =>
        dayjs(startDate).format(dayMonthYearBackSlash)
    },
    {
      key: 'endDate',
      title: `${t('common.date')} ${t('treatments.treatment_end_date')}`,
      render: (_, { endDate }) => dayjs(endDate).format(dayMonthYearBackSlash)
    },
    {
      key: 'type',
      title: t('treatments.treatment_type'),
      render: (_, { translation }) =>
        (currentLang.value === 'ro' ? translation?.ro : translation?.ru) ?? '-'
    },
    ...(showPerson
      ? [
          {
            key: 'last name',
            dataIndex: ['person', 'lastName'],
            title: t('form.last_name')
          },
          {
            key: 'first name',
            dataIndex: ['person', 'firstName'],
            title: t('form.first_name')
          }
        ]
      : []),
    {
      key: 'status',
      title: t('analysis.status'),
      render: (_, { status }) => <TreatmentStatusTag status={status} />
    },
    {
      key: 'actions',
      align: 'end',
      fixed: 'right',
      render: ({ id, person }) => (
        <Button
          type="link"
          onClick={() =>
            navigate(
              isSimeTB
                ? paths.patients.simeTB.details(
                    String(personId ?? person?.id),
                    simeTBPersonId,
                    id
                  )
                : paths.patients.treatments.details(
                    String(personId ?? person?.id),
                    id
                  )
            )
          }
        >
          {t('common.see_details')}
        </Button>
      )
    }
  ]

  return { columns }
}
